import styled from 'styled-components';

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  height: 100%;
  width: 100%;

  @media (max-width: 900px) {
    flex-direction: column;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  max-width: 1180px;
  padding: 3rem 2rem;
  gap: 1.5rem;

  .button-card-pix {
    width: 100%;
    padding: 0 !important;

    .cnt-card-pix {
      width: 100%;
      height: 70px;
      background: ${({ theme }) => theme.colors.background_white} 0% 0% no-repeat padding-box;
      border-radius: 8px;
      opacity: 1;
      padding: 10px 10px;
      display: flex;
      justify-content: center;

      img {
        width: 100%;
      }
    }

    :hover {
      background: transparent;
    }
  }

  .cnt-wallet {
    width: 30%;
    padding: 1rem;
    max-height: 60vh;
    overflow-y: scroll;
    background: ${({ theme }) => theme.colors.background} 0% 0% no-repeat padding-box;
    border-radius: 16px;
    opacity: 1;
    display: flex;
    flex-direction: column;
    padding: 1rem;

    ::-webkit-scrollbar {
      width: 5px;
      background-color: ${({ theme }) => theme.colors.background_white};
    }

    ::-webkit-scrollbar:horizontal {
      height: 5px;
    }

    ::-webkit-scrollbar-track,
    ::-webkit-scrollbar-track-horizontal {
      border-radius: 10px;
    }

    ::-webkit-scrollbar-thumb,
    ::-webkit-scrollbar-thumb:horizontal {
      background-color: ${({ theme }) => theme.colors.tertiary_500};
      border-radius: 10px;
    }

    .wallet-header {
      display: flex;
      align-items: center;
      flex-direction: row;
      gap: 0.5rem;

      .icon-wallet {
        color: ${({ theme }) => theme.colors.primary};
      }

      span {
        text-align: left;
        font: normal normal normal 20px/26px Futura PT;
        letter-spacing: 0px;
        color: ${({ theme }) => theme.colors.primary};
        opacity: 1;
        padding-left: 10px;
      }
    }

    .wallet-body {
      display: flex;
      max-height: 40rem;
      overflow-y: auto;
      flex-direction: column;
      gap: 1rem;

      .cnt-add-wallet {
        border-radius: 8px;
        opacity: 1;
        height: 69px;
        display: flex;
        justify-content: center;
        align-items: center;

        .button-add {
          padding: 0;
        }

        .add-wallet {
          display: flex;
          flex-direction: row;
          align-items: center;
          height: 40px;
          border: 1px dashed ${({ theme }) => theme.colors.gray_275};
          opacity: 1;
          border-radius: 8px;
          padding: 0px 10px;

          span {
            padding-left: 5px;
            color: ${({ theme }) => theme.colors.gray_275};
            text-align: left;
            font: normal normal normal 16px/21px Futura PT;
            letter-spacing: 0px;
            text-transform: lowercase;
            opacity: 1;
          }

          .icon-add {
            color: ${({ theme }) => theme.colors.gray_275};
          }
        }
      }

      .content-banks {
        display: flex;
        flex-direction: column;
        gap: 1rem;
      }
    }
  }

  .cnt-pix {
    display: flex;
    flex-direction: column;
    width: 50%;
    gap: 1rem;

    .header-pix {
      h1 {
        letter-spacing: 0px;
        color: ${({ theme }) => theme.colors.primary};
        opacity: 1;
      }
    }

    .form-pix {
      display: flex;
      flex-direction: column;
      gap: 1.5rem;
    }

    .qrCode {
      display: flex;
      flex-direction: row;

      .img-qrCode {
        padding-top: 30px;
        max-width: 300px;

        img {
          max-height: 300px !important;
        }

        .title-pix {
          text-align: left;
          padding-bottom: 15px;
          font: normal normal 300 16px/23px Futura PT;
          letter-spacing: -0.4px;
          color: ${({ theme }) => theme.colors.secondary};
          opacity: 1;
        }
      }

      .icons-pix {
        display: flex;
        flex-direction: column;
        align-items: baseline;
        justify-content: flex-end;
        padding-left: 30px;
        text-align: left;
        font: normal normal normal 14px/23px Futura PT;
        letter-spacing: -0.35px;
        color: ${({ theme }) => theme.colors.tertiary_500};
        opacity: 1;

        .qrCode-share {
          display: flex;
          justify-content: center;
          align-items: center;

          .icon-share {
            padding-right: 5px;
          }

          svg {
            width: 15px;
          }
        }

        .qrCode-exclude {
          padding-top: 15px;
          display: flex;
          justify-content: center;
          align-items: center;

          .icon-delete {
            padding-right: 5px;
            fill: ${({ theme }) => theme.colors.tertiary_500};
          }

          svg {
            width: 15px;
            color: ${({ theme }) => theme.colors.tertiary_500};
          }
        }
      }
    }

    .options-saved {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;

      .cnt-savePix {
        display: flex;
        justify-content: flex-end;

        .button-savePix {
          background: ${({ theme }) => theme.colors.background_white} 0% 0% no-repeat padding-box;
          border: 1px solid ${({ theme }) => theme.colors.tertiary_500};
          border-radius: 12px;
          opacity: 1;
          width: 85px;
          height: 23px;
          text-align: left;
          font: normal normal normal 12px/16px Futura PT;
          letter-spacing: 0px;
          color: ${({ theme }) => theme.colors.tertiary_500};
          opacity: 1;
        }
      }
    }
  }

  .cnt-account {
    display: flex;
    flex-direction: column;
    width: 50%;
    gap: 1rem;

    .header-account {
      h1 {
        letter-spacing: 0px;
        color: ${({ theme }) => theme.colors.primary};
        opacity: 1;
      }
    }

    .cnt-form {
      display: flex;
      flex-direction: column;
      gap: 1.5rem;

      .text-span {
        text-align: left;
        margin-top: 10px;
        font: normal normal 300 22px/23px Futura PT;
        letter-spacing: -0.55px;
        color: ${({ theme }) => theme.colors.gray};
        opacity: 1;
      }

      .dropdown {
        font: normal normal 300 22px/23px Futura PT;
        letter-spacing: -0.55px;
        color: ${({ theme }) => theme.colors.gray};
        opacity: 1;

        .css-et6z77-MuiInputBase-root {
          width: 100%;
        }

        .css-1nrlq1o-MuiFormControl-root {
          width: 100%;
        }
      }
    }

    .options-saved {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;

      .button-add {
        text-align: left;
        font: normal normal normal 12px/16px Futura PT;
        letter-spacing: 0px;
        color: ${({ theme }) => theme.colors.tertiary_500};
        opacity: 1;
        border-radius: 12px;
        background: ${({ theme }) => theme.colors.background_white} 0% 0% no-repeat padding-box;
        border: 1px solid ${({ theme }) => theme.colors.tertiary_500};
        width: 85px;
        height: 23px;
      }
    }
  }

  .account-created {
    display: flex;
    flex-direction: column;
    margin-left: 20px;

    .card-options {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      padding-top: 20px;
      padding: 15px 5px 0px 5px;
      text-align: left;
      font: normal normal 300 20px/23px Futura PT;
      letter-spacing: -0.5px;
      color: ${({ theme }) => theme.colors.gray};
      opacity: 1;
      gap: 0.5rem;

      .checkbox-options {
        display: flex;
        align-items: center;
      }

      .actions {
        display: flex;
        gap: 0.5rem;

        .edit {
          padding: 0;
          min-width: 15px;

          svg {
            height: 1.1rem;
            fill: ${({ theme }) => theme.colors.tertiary_500};
          }
        }

        .delete {
          padding: 0;
          min-width: 15px;

          svg {
            height: 1.1rem;
            fill: ${({ theme }) => theme.colors.error};
          }
        }
      }
    }
  }

  @media (max-width: 900px) {
    width: -webkit-fill-available;
    padding: 1rem 1.5rem;
    gap: 0.5rem;

    .cnt-pix {
      padding-left: 20px;
      width: 50%;
    }

    .cnt-account {
      padding-left: 20px;
      width: 50%;
    }

    .cnt-wallet {
      width: 40%;
    }
  }

  @media (max-width: 500px) {
    flex-direction: column;
    gap: 1rem;

    .account-created {
      margin-left: 0;
    }

    .cnt-pix {
      padding-left: 0;
      width: 100%;
    }

    .cnt-account {
      padding-left: 0;
      width: 100%;
    }

    .cnt-wallet {
      width: -webkit-fill-available;
      max-height: 48vh;
    }
  }

  @media (max-width: 320px) {
    padding: 0.5rem;
  }
`;
